/**
 * Quick Add Cart Handler — AJAX add-to-cart for inline product card forms
 *
 * Uses event delegation on `document` so it works with AJAX-injected cards
 * (collection pill switching, infinite scroll, etc.) without needing to
 * re-bind handlers after each render.
 *
 * Loaded once via <script defer> from layout/theme.liquid. The internal
 * `window.quickAddInitialized` guard makes accidental double-loads harmless.
 *
 * NOTE: This file is distinct from Dawn's `quick-add.js`, which defines
 * the <quick-add-modal> custom element used by other sections.
 */
(function() {
  if (window.quickAddInitialized) return;
  window.quickAddInitialized = true;

  document.addEventListener('submit', function(e) {
    var form = e.target.closest('.quick-add-form');
    if (!form) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    if (!btn || btn.disabled) return;

    var textEl = btn.querySelector('.add-to-cart-btn__text');
    var spinnerEl = btn.querySelector('.add-to-cart-btn__spinner');
    var variantId = form.querySelector('input[name="id"]').value;

    // Show spinner, disable button
    btn.disabled = true;
    btn.classList.add('loading');
    if (textEl) textEl.classList.add('hidden');
    if (spinnerEl) spinnerEl.classList.remove('hidden');

    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: parseInt(variantId), quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function(s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function(r) { return r.json(); })
    .then(function(data) {
      if (data.status && data.status !== 200) {
        // Error: show error text briefly
        btn.classList.remove('loading');
        if (spinnerEl) spinnerEl.classList.add('hidden');
        if (textEl) { textEl.classList.remove('hidden'); textEl.textContent = 'Error'; }
        setTimeout(function() {
          if (textEl) textEl.textContent = 'ADD TO CART';
          btn.disabled = false;
        }, 2000);
        return;
      }

      // Success: open drawer with real content
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty');
        if (data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } else {
          cartDrawer.open();
        }
      }

      // Show "Added!" briefly
      btn.classList.remove('loading');
      if (spinnerEl) spinnerEl.classList.add('hidden');
      if (textEl) { textEl.classList.remove('hidden'); textEl.textContent = 'Added!'; }
      setTimeout(function() {
        if (textEl) textEl.textContent = 'ADD TO CART';
        btn.disabled = false;
      }, 1500);
    })
    .catch(function(error) {
      console.error('Add to cart error:', error);
      btn.classList.remove('loading');
      if (spinnerEl) spinnerEl.classList.add('hidden');
      if (textEl) textEl.classList.remove('hidden');
      btn.disabled = false;
    });
  });
})();
